import React from 'react';
import DataEntry from './DataEntry';
import Administration from './Administration';
import Outputs from './Outputs';

let list = [];

export default function (props) {

  list = [...DataEntry, ...Administration, ...Outputs];

  return (
    <div>
      {list.map((h, index) => (
        <p style={{ fontSize: "14px" }} key={`mi-${index}`}>{(props.value === h.link) ? h.title : ''}</p>
      )
      )}
    </div>
  )
}